import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("页面栏位")
const _hoisted_2 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-danger" }, "下线", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("正常")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("下线")

import {ref, onMounted, reactive, watch} from "vue";
import Datatable from "@/components/kt-datatable/Datatable2.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  tab: { type: String, required: true },
},
  setup(__props) {

const props = __props



const dataT = ref<HTMLElement | null>(null);
const apiUrl = 'm/collection';
const tableHeader = ref([
  { name: "日志目录", key: "site" },
  { name: "事件名称", key: "key" },
  { name: "页面", key: "source" },
  { name: "栏位", key: "position", width: 150 },
  { name: "状态", key: "is_online", width: 60},
]);
const filters = reactive({});
const formData = reactive({
  id: 0,
  site: '',
  key: '',
  source: '',
  position: '',
  is_online: true,
  reason: '',
});
const rules = {
  site: [
    { required: true, message: '请输入日志目录！', trigger: 'blur' },
  ],
  key: [
    { required: true, message: '请输入事件名称！', trigger: 'blur' },
  ],
  source: [
    { required: true, message: '请输入页面名称！', trigger: 'blur' },
  ],
  position: [
    { required: true, message: '请输入栏位名称！', trigger: 'blur' },
  ],
};

onMounted(() => {
});


watch(props, (val) => {
  if (props.tab === '页面栏位'){
    (dataT as any).value.setCurrent(1);
  }
});

const loadHeader = (func) => {
  return true;
}

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createBlock(Datatable, {
    ref_key: "dataT",
    ref: dataT,
    apiUrl: apiUrl,
    "table-header": tableHeader.value,
    "enable-items-per-page-dropdown": false,
    data: _unref(formData),
    rules: rules,
    filters: _unref(filters),
    title: "页面栏位",
    preLoad: loadHeader
  }, {
    search: _withCtx(() => [
      _hoisted_1
    ]),
    "cell-is_online": _withCtx(({ row: r }) => [
      (r.is_online === true)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "正常"))
        : (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 1,
            content: r.reason
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 2
          }, 1032, ["content"]))
    ]),
    form: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "日志目录",
        prop: "site"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _unref(formData).site,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).site) = $event)),
            placeholder: "日志目录"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "事件名称",
        prop: "key"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _unref(formData).key,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).key) = $event)),
            placeholder: "事件名称"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "页面名称",
        prop: "source"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _unref(formData).source,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).source) = $event)),
            placeholder: "页面名称"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "栏位名称",
        prop: "position"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _unref(formData).position,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).position) = $event)),
            placeholder: "栏位名称"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "状态",
        prop: "is_online"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio_group, {
            modelValue: _unref(formData).is_online,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).is_online) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio, {
                label: true,
                value: true
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio, {
                label: false,
                value: false
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "原因",
        prop: "reason"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "text",
            modelValue: _unref(formData).reason,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).reason) = $event)),
            placeholder: "下线/恢复原因"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["table-header", "data", "filters"]))
}
}

})